var per_click = 4;
var reviews = [];

$(document).ready(function() {

	/*===============================================
	=            Product reviews section            =
	===============================================*/
	$('.rating_list').off('click');
	
		$.ajax({
            type:       'POST',
            url:        base_url+'/products/get_reviews',
            data:       {product_id:$('input[name=product_id]').val()},
            dataType:   'json',
            success:    function(json){
            	if(json.status=='success'){
            		fetch_init_reviews(json.reviews,per_click);
            	}
            }
        });

	/*************************************************************************/
	/*************initialize the lightbox for product images *****************/
	/*************************************************************************/


	$('.flexslider2').flexslider({
        animation: "slide",
        selector:".slides2 > li",
        animationLoop: false,
        slideshow:false,
        itemWidth: 100,
        itemMargin: 5,
        controlNav:false
      });

	/*if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {*/

	  	//removed thumbs from product page to stop the image zoom breaking entire page

		$('.thumbs').click(function(){
			//get clicked link data image source
			$('#zoom_03').attr('src',$(this).data('image'));
			//change large image source
			$('#zoom_03').data('zoom-image',$(this).data('zoom-image'));
			//set the index identifier to the correct index
			$('#zoom_03').data('index',$(this).data('index'));
		});

		var pswpElement = document.querySelectorAll('.pswp')[0];

		var items = [];

		//get gallery images
		$('.slides2').find('li').each(function(){
			
			items.push({
				src:$(this).data('zoom-image'),
				w: 800,
		        h: 800
			});
		});

	  	//removed thumbs from product page to stop the image zoom breaking entire page

		// Initializes and opens PhotoSwipe
		$('#zoom_03').click(function(){
			index = $(this).data('index');
			var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, {index:index,shareEl: false});
			gallery.init();
		});


	/*}else{

		$("#zoom_03").elevateZoom({
				gallery:'gallery_01', 
				cursor: 'crosshair', 
				zoomType: "inner",
				responsive:true,
				easing:true,
				galleryActiveClass: 'active',
				zoomWindowFadeIn: 500,
				zoomWindowFadeOut: 500,
				lensFadeIn: 500,
				lensFadeOut: 500
				});



		$('.thumbs').click(function(){
			$('#zoom_03').data('index',$(this).data('index'));
		});

		$("#zoom_03").bind("click", function(e) { 
			index = $(this).data('index');
			var ez = $('#zoom_03').data('elevateZoom');

			ez.closeAll();

			var items = [];

			$('.slides2').find('a').each(function(){

				items.push({
					href:$(this).data('zoom-image')
				});

			});

			$.fancybox.open(items,{
				prevEffect	: 'none',
				nextEffect	: 'none',
				index:index,
				helpers	: {
					thumbs	: {
						width	: 50,
						height	: 50
					}
				}
			}); 
			return false; 
		});
	}*/

	/*************************************************************************/
	/*************initialize the lightbox for the wireframe ******************/
	/*************************************************************************/

	$('.open_wireframe').click(function(){

		//get all images links and titles and create objects which are grouped into an array
		fancy_images = [];
		$('.thumbs').each(function(){
			fancy_item = {href:$(this).data('zoom-image')}
			fancy_images.push(fancy_item);
		});
		index = 0;
		index = fancy_images.length -1 ;
		//open the box with the images array and parameters
		$.fancybox.open(fancy_images,
		{
			prevEffect	: 'none',
			nextEffect	: 'none',
			index:index,
			helpers	: {
				thumbs	: {
					width	: 50,
					height	: 50
				}
			}
		});
	});
		

	///////////////////////////////////////////
	/************** star rating **************/
	///////////////////////////////////////////
	$('.rating_stars').raty({ 
		starType: 'i',
		readOnly:true,
		half:true,
		score: function() {
              return $(this).attr('data-rating');
             }
	});

	/**************** video gallery plugin initialization *****************/

	$('#video-gallery').royalSlider({
		    arrowsNav: false,
		    fadeinLoadedSlide: true,
		    controlNavigationSpacing: 0,
		    controlNavigation: 'thumbnails',
		    autoHideControlNav:true,
		    fullscreen: {
		    		// fullscreen options go gere
		    		enabled: true,
		    		native: true
		    },
		    thumbs: {
		      autoCenter: false,
		      fitInViewport: true,
		      orientation: 'vertical',
		      spacing: 0,
		      paddingBottom: 0
		    },
		    keyboardNavEnabled: false,
		    imageScaleMode: 'fill',
		    imageAlignCenter:true,
		    slidesSpacing: 0,
		    loop: false,
		    loopRewind: true,
		    numImagesToPreload: 3,
		    video: {
		      autoHideArrows:true,
		      autoHideControlNav:false,
		      autoHideBlocks: true
		    }, 
		    autoScaleSlider: true, 
		    autoScaleSliderWidth: 960,     
		    autoScaleSliderHeight: 450,
		    imgWidth: 640,
		    imgHeight: 360
		
		  });

	/****************** fix video player shrink problem *****************/
		$('.tabs').bind('easytabs:before',function(){
			$('.royalSlider').hide();
		});
		
		$('.tabs').bind('easytabs:after',function(){
			$('.royalSlider').royalSlider('updateSliderSize', true);
			$('.royalSlider').slideDown('slow');
		});
	

});



function fetch_init_reviews(json_reviews,per_click){
	reviews = json_reviews;
	
	if(reviews.length==0){
		$('.rating_list').css('cursor', 'default');
		$('.star-on-png').css('cursor', 'default');
		$('.rating_stars').css('cursor', 'default');
		$('.product_item_rating_text').css('cursor', 'default');
	}
	//if there is more reviews than the initial batch show the view more btn
	if(reviews.length>per_click){
		//then show the view more btn
		load_more  = '<div class="col-sm-12 t_align_c" id="load_more_reviews_btn_block">';
		load_more += 	'<button class="fs_medium button_type_2 color_purple transparent r_corners tr_all" id="load_more_reviews">Load more</button>';
		load_more += '</div>';
		$('#reviews').append(load_more);
		$('#load_more_reviews').click(function(){
			append_more_reviews();
		});
	}
	//get initial reviews
	init_reviews = reviews.splice(0,per_click);
	//loop though init reviews and display them on the screen
		console.log();

	init_reviews.forEach(function(review){
		review_tpl = generate_review(review);
		if($('#load_more_reviews_btn_block').length==0){
			if($('#reviews').is(':visible')){
				$('#reviews').append(review_tpl).fadeIn('slow');
			}else{
				$('#reviews').append(review_tpl);
			}
		}else{
			if($('#reviews').is(':visible')){
				$('#load_more_reviews_btn_block').before(review_tpl).fadeIn('slow');
			}else{
				$('#load_more_reviews_btn_block').before(review_tpl);
			}
		}
	});
}

function generate_review(review)
{
	$review_tpl  ='<div class="col-md-6 col-sm-12 comment_block_main">';
	$review_tpl +=	'<div class="m_bottom_20 comment_block">';
	$review_tpl +=		'<div class="d_table w_full m_bottom_10">';
	$review_tpl +=			'<div class="d_table_cell">';
	$review_tpl +=				'<div class="d_inline_m">';
	$review_tpl +=					'<p class="fs_large color_dark tr_all"><b>'+review.customer_name+'</b>  <span class="fs_medium color_grey d_mxs_none"></p>';
	$review_tpl +=				'</div>';
	$review_tpl +=			'</div>';
	$review_tpl +=			'<div class="d_table_cell t_align_r v_align_t d_mxs_none">';
	$review_tpl +=				'<ul class="rating_list d_inline_m hr_list tr_all">';

	for (var i = 0; i < review.rating; i++) {
		$review_tpl +=					    '<li class="relative active lh_ex_small">';
		$review_tpl +=							'<i class="icon-star-empty-1 color_grey_light_2 tr_all"></i>';
		$review_tpl +=							'<i class="icon-star-1 color_yellow tr_all"></i>';
		$review_tpl +=						'</li>';
	};

	for (var i = 0; i < 5-(review.rating); i++) {
		$review_tpl +=					    '<li class="relative lh_ex_small">';
		$review_tpl +=							'<i class="icon-star-empty-1 color_grey_light_2 tr_all"></i>';
		$review_tpl +=							'<i class="icon-star-1 color_yellow tr_all"></i>';
		$review_tpl +=						'</li>';
	}					

	$review_tpl +=				'</ul>';
	$review_tpl +=			'</div>';
	$review_tpl +=		'</div>';
	$review_tpl +=		'<div class="comment relative r_corners fw_light">'+review.comment+'</div>';
	$review_tpl +=	'</div>';
	$review_tpl +='</div>';
	return $review_tpl;
}

function append_more_reviews()
{	
	reviews_chunk = reviews.splice(0,per_click);

	reviews_chunk.forEach(function(review){
		review_tpl = generate_review(review);
		$('#load_more_reviews_btn_block').before(review_tpl).fadeIn('slow');
	});

	if(reviews.length<=0){
		//then hide the view more btn
		$('#load_more_reviews').parent().hide();
	}
}